import DiscoverFilterDialogHeader from './DiscoverFilterDialogHeader';

export default DiscoverFilterDialogHeader;
